import React, { PureComponent } from 'react';
import { VirtualBrand, VirtualPack } from '~/Api/Analytics/VirtualBrand';
import { AnalyticDataSources } from '~/Api/Analytics/VirtualBrand/mapAnalyticVirtualBrand';
import LowestPrices from '~/MedicinalBrandsAnalytics/VirtualBrand//LowestPrices';
import AvailabilityList from '~/MedicinalBrandsAnalytics/VirtualBrand/AvailabilityList';

import styles from './styles.less';

interface Props {
	virtualBrand: VirtualBrand;
	virtualBrandAvailability: { [countryCode: string]: AnalyticDataSources };
	virtualPackAvailability: { [virtualPackId: string]: { [countryCode: string]: AnalyticDataSources } };
	virtualPack: VirtualPack | null;
	currency: string | null;
}

export default class InfoTab extends PureComponent<Props> {
	render() {
		const { virtualBrand, virtualBrandAvailability, virtualPackAvailability, virtualPack, currency } = this.props;
		const { mostAvailablePack } = virtualBrand;

		return (
			<div className={styles.container}>
				<div className={styles.availability}>
					<h2 className={styles.heading}>Availability:</h2>
					<AvailabilityList
						availability={virtualPack ? virtualPackAvailability[virtualPack.id] || {} : virtualBrandAvailability}
					/>
				</div>
				<div className={styles.price}>
					{mostAvailablePack && currency && !mostAvailablePack.other ? (
						<LowestPrices virtualPack={mostAvailablePack} />
					) : null}
				</div>
			</div>
		);
	}
}
